import React, { useState, useEffect } from 'react';
import { inject } from 'mobx-react';
import { Col, Row } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import applicationRouter from '~/hoc/applicationRouter'
import UserProfileLogo from '../../../components/UserProfileLogo';
import TimeBankList from './TimeBankList';

//elements
import LoadingSpinner from '../../../elements/LoadingSpinner.js';

const TimeBankMemberList = ({ timeBankStore, t, userStore }) => {
    const [timeBankMember, setTimeBankMember] = useState([]);
    const [currentMemberId, setCurrentMemberId] = useState(null);
    const [filterName, setFilterName] = useState('');
    const currentUser = userStore?.currentUser;
    const isMember = currentUser.user_type === 'member';

    useEffect(() => {
        const loadData = async () => {
            let pmMembers = '';
            if (currentUser.user_type !== 'admin' && currentUser?.Manages?.length) {
                pmMembers = currentUser.Manages.join(',');
            }
            const members = await timeBankStore.loadTimeBankMember({ pmMembers });
            const currMem = timeBankStore?.filters?.currentUserTimeBankList ? members?.find(ele => ele?.id === timeBankStore?.filters?.currentUserTimeBankList) : members[0]
            setCurrentMemberId(currMem)
            setTimeBankMember(members);
            timeBankStore.setFilter('currentUserTimeBankList', currMem?.id)
        };
        loadData();
    }, []);

    useEffect(() => {
        if (!filterName)
            setTimeBankMember(timeBankStore?.currentMemberList)
    }, [filterName])

    const handleSearch = () => {
        if (!filterName)
            setTimeBankMember(timeBankStore?.currentMemberList);
        const filterTimeBank = timeBankStore?.currentMemberList?.filter(ele => ele?.name?.toLowerCase().includes(filterName.toLowerCase()));
        setTimeBankMember(filterTimeBank);
    }

    const handleMemberList = (entity) => {
        setCurrentMemberId(entity)
        timeBankStore.setFilter('currentUserTimeBankList', entity.id)
        timeBankStore.onFilter();
    }

    const reloadTimebankBalance = async (id) => {
        let pmMembers = '';
        if (currentUser.user_type !== 'admin' && currentUser?.Manages?.length) {
            pmMembers = currentUser.Manages.join(',');
        }
        const members = await timeBankStore.loadTimeBankMember({ pmMembers });
        setTimeBankMember(members);
        timeBankMember.map(ele => {
            if (ele.id === id) {
                const currMem = timeBankStore?.filters?.currentUserTimeBankList ? members?.find(ele => ele?.id === timeBankStore?.filters?.currentUserTimeBankList) : members[0]
                setCurrentMemberId(currMem)
            }
        })
    }

    if (timeBankStore.loading) return <LoadingSpinner />;

    return (
        <Row className="border border-radius-10" style={{ maxHeight: '120vh', minHeight: '70vh', height: '120vh', overflow: 'hidden' }}>
            {!isMember &&
                <Col xs={12} md={3} className='p-0 mb-3 mb-md-0'>
                    <div className="border border-radius-10" style={{ maxHeight: '100%', overflow: 'auto' }}>
                        <h5 className='fw-600 m-2 mb-4'>{t('Members')}</h5>
                        <div className="conversation-search m-2 mb-4">
                            <input
                                type="text"
                                className="conversation-search-input"
                                placeholder={t('Search')}
                                onChange={(e) => setFilterName(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.code === 'Enter')
                                        handleSearch();
                                }}
                                value={filterName}
                            />
                            <i className="fa fa-search conversation-search-icon" onClick={() => handleSearch()} />
                        </div>
                        {timeBankMember.length > 0 ?
                            <div className={"overflow-auto"} style={{ height: '680px'}} >
                                {timeBankMember.map((ele, index) => (
                                    <div key={index}
                                        className={`d-flex align-items-center cursor-pointer border-top-1 ${currentMemberId?.id === ele?.id ? 'custom-active-bg' : ''}`}
                                        onClick={() => handleMemberList(ele)}>
                                        <UserProfileLogo image_id={ele?.image ? ele.image : false} width='35px' height="35px" className={'m-2'} />
                                        <span className='ml-10 d-flex align-items-center'>{ele.name}</span>
                                    </div>
                                ))}
                            </div>
                            :
                            <div className='d-flex justify-content-center fw-600'>{t('No data found')}</div>
                        }
                    </div>
                </Col>
            }
            <Col xs={12} md={isMember ? 12 : 9}>
                {(currentMemberId?.id || isMember) ?
                    <TimeBankList
                        userDetails={currentMemberId}
                        reloadTimebankBalance={reloadTimebankBalance}
                    />
                    :
                    <div className='d-flex justify-content-center fw-600 align-items-center h-100'>{t('No data found')}</div>
                }
            </Col>
        </Row>
    );
};

export default inject('userStore', 'timeBankStore')(applicationRouter(withLocalization(TimeBankMemberList)));